import React, { Fragment, useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { operationsHelper } from "../../helpers/operations"
import { documentsActions } from "../../actions/documentsActions"
import Tooltip from "@material-ui/core/Tooltip"
import MetadataLayoutDetails from "../general/MetadataLayoutDetails"
import Pagination from "../common/Pagination"
//import PaginationInput from "../common/PaginationInput";
import CommentsList from "../documents/CommentsList"
import CommentsDetailsModal from "../documents/CommentsDetailsModal"
import axios from "../../services/axios"
import TagsUpdateDropdown from "../common/TagsUpdateDropdown"
import { getCommentsCount, RECORDS_PER_PAGE, PAGINATION_DELAY, useDebounce } from "../../utils"
import { getFileListRequest } from "../../actions/searchActions"
import Axios from "axios"

const FilesList = ({
	filtersButton,
	requestByFilters,
	elementsFilter,
	saveElementsFilter,
	filterDate,
	filterList,
	needToFilter,
	setNeedToFilter,
	tagsList,
	setTagsList,
	setResetPage,
	resetPage,
	currentTag,
	currentSort,
}) => {
	/* ******************* REDUX STORE ******************* */
	//Redux actions
	const dispatch = useDispatch()
	// const globalStateSearchDocumentList=useSelector((state) => state.search.searchResults);
	const conceptsOfSearch = useSelector((state) => state.search.concept_target_terms)
	const currentSearch = useSelector((state) => state.currentSearchs.search)
	const downloadDocs = useSelector((state) => state.downloads.documents)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const updateCommentsRequest = useSelector((state) => state.document.reloadComments)
	const comentsCount = useSelector((state) => state.document.doc_counts)
	const searchedDocs = useSelector((state) => state.search.searchDocViewResults)
	const selectedBaseId = useSelector((state) => state?.multiBase?.selectedBase?.project_id)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Elements Data
	const [searchDocumentsList, setSearchDocumentslist] = useState({ count: 0, data: [] })
	// State for manage the elements mouseOver
	const [itemId, setItemId] = useState()
	// Select Identify
	const [selectIdentify, setSelectIdentify] = useState({
		show: false,
		value: "",
		elementId: "",
	})
	// Select MouseOver / MouseOut
	const [selectOver, setSelectOver] = useState(false)
	const [columns, setColumns] = useState(3)
	const [selectColumns, setSelectColumns] = useState(false)
	const [totalpages, setTotalPages] = useState(1)
	const [currentpage, setCurrentPage] = useState(1)
	const [inputPageNumber, setInputPageNumber] = useState(currentpage)

	//Current hightlight text word index
	const [hightlightIndex, setHightlightIndex] = useState({})
	const [elementsPerPage, setElementsPerPage] = useState(20)
	const [calcTotalPages, setCalcTotalPages] = useState(1)

	// Documents metadata
	const [documentMetadata, setDocumentMetadata] = useState({})
	// Documents Contents
	const [documentContent, setDocumentContent] = useState({})
	// Latest Id Request
	const [latestIdRequest, setLatestIdRequest] = useState()
	//Docs to show - Pagination
	const [docsToSHow, setDocsToSHow] = useState({ count: 0, data: [] })

	const [cancelRequestToken, setCancelRequestToken] = useState({ old: null, new: null })

	//To refresh docs rendering
	const [documentRenderingPrefix, setDocumentRenderingPrefix] = useState(0)

	const [showingCommentBox, setShowingCommentBox] = useState(false)
	const [showingCommentBoxId, setShowingCommentBoxId] = useState(null)

	//Docs Comments
	const [comment, setComment] = useState("")
	const [commentList, setCommentList] = useState({})
	const [commentContent, setCommentContent] = useState()

	// Refresh element
	const [idElement, setIdElement] = useState(Math.random())

	/* ******************* END REACT STATES ******************* */

	const debouncedTerm = useDebounce(inputPageNumber, PAGINATION_DELAY)

	/* ******************* VARIABLES INITIALIZATION ******************* */
	// Pagination
	//let elementsPerPage = 20;
	//let calcTotalPages = Math.ceil(searchDocumentsList.data.length / elementsPerPage);
	/* ******************* END VARIABLES INITIALIZATION ******************* */

	/* ******************* USE-EFFECTS ******************* */

	const opcionesCampos = [
		"subject",
		"to",
		"from",
		"page_number",
		"total_page_number",
		"author",
		"file_name",
		"filepath",
		"filename",
		"category",
		"comments",
		"content_status",
		,
		"identifier",
		"keywords",
		"language",
		"title",
		"version",
	]

	useEffect(() => {
		if (debouncedTerm !== "" && Number(debouncedTerm) >= 1 && Number(debouncedTerm) <= totalpages) setCurrentPage(Number(debouncedTerm))
		else {
			setInputPageNumber(currentpage)
		}
	}, [debouncedTerm])

	useEffect(() => {
		if (searchDocumentsList.hasOwnProperty("data") && searchDocumentsList?.count && Array.isArray(searchDocumentsList.data)) {
			// return;

			let ids = [...searchDocumentsList.data]

			let idList = ids.map((item) => item.id)

			//  if (searchDocumentsList.count > 0){
			//Check if content exclide filter is active
			let auxToShow = searchDocumentsList.data.filter((elementoDoc) =>
				operationsHelper.hideForSpecificWord(
					elementoDoc.content,
					filtersButton.specificWordExclude,
					filtersButton.searchWordExclude
				) === false
					? elementoDoc
					: null
			) //To do: need to check
			// auxToShow = auxToShow.slice((20*(currentpage -1 )), (20*currentpage -1));

			setDocsToSHow({
				count: auxToShow.length,
				data: auxToShow,
			})

			if (idList !== latestIdRequest) {
				setLatestIdRequest(idList)
				setDocumentContent({})
				setDocumentMetadata({})

				let contentDoc = ids
				let datosGenerales
				let subject
				let to
				let from
				let date
				let page_number = ""
				let total_page_number = ""
				let author = ""
				let filename = ""
				let file_name = ""
				let filepath = ""
				let category = ""
				let comments = ""
				let content_status = ""
				let identifier = ""
				let keywords = ""
				let language = ""
				let title = ""
				let version = ""

				auxToShow.map((item, i) => {
					let auxDoc = documentContent
					auxDoc[item.id] = item.content
					datosGenerales = searchedDocs.data.filter((i) => i["id"] === item.id)
					subject = ""
					to = ""
					from = ""
					date = ""
					page_number = ""
					total_page_number = ""
					author = ""
					filename = ""
					file_name = ""
					filepath = ""
					category = ""
					comments = ""
					content_status = ""
					identifier = ""
					keywords = ""
					language = ""
					title = ""
					version = ""

					if (datosGenerales.length > 0) {
						opcionesCampos.forEach(function (index) {
							if (datosGenerales[0].hasOwnProperty(index)) {
								eval(index + "=" + "`${datosGenerales[0][index]}`")
							}
						})
						if (datosGenerales[0].hasOwnProperty("tagged_date") && datosGenerales[0]["tagged_date"] !== undefined) {
							date = datosGenerales[0]["tagged_date"]
						} else if (datosGenerales[0].hasOwnProperty("creation_time") && datosGenerales[0]["creation_time"] !== undefined) {
							date = datosGenerales[0]["creation_time"]
						} else {
							date = Math.floor(Date.now() / 1000)
						}
					}
					setDocumentContent(auxDoc)

					let auxDocMetadata = documentMetadata
					auxDocMetadata[item.id] = {
						subject: subject,
						to: to,
						from: from,
						date: date,
						page_number: page_number,
						total_page_number: total_page_number,
						author: author,
						filename: filename,
						file_name: file_name,
						filepath: filepath,
						category: category,
						comments: comments,
						content_status: content_status,
						identifier: identifier,
						keywords: keywords,
						language: language,
						title: title,
						version: version,
					}
					setDocumentMetadata(auxDocMetadata)
				})
				// setDocumentRenderingPrefix(Math.round(Math.random() * 20) - 10);
			}
		} else {
			setDocsToSHow({
				count: 0,
				data: [],
			})
		}
	}, [searchDocumentsList, currentpage, filtersButton.specificWordExclude, filtersButton.searchWordExclude])

	useEffect(() => {
		setCurrentPage(1)
		const payload = getSearchPayload()
		setCancelRequestToken({ old: cancelRequestToken.new, new: Axios.CancelToken.source() })
		dispatch(getFileListRequest(payload))
		// if (!!currentSearch.text || !!currentSearch.concepts.length) {
		// 	setCurrentPage(1)
		// 	const payload = getSearchPayload()
		// 	setCancelRequestToken({ old: cancelRequestToken.new, new: Axios.CancelToken.source() })
		// 	dispatch(getFileListRequest(payload))
		// }
	}, [
		currentSearch.text,
		currentSearch.concepts,
		filtersButton.fromDate,
		filtersButton.toDate,
		requestByFilters,
		currentTag,
		currentSort,
	])

	useEffect(() => {
		//if (!!currentSearch.text || !!currentSearch.concepts.length) {
		setInputPageNumber(currentpage)
		const payload = getSearchPayload()
		setCancelRequestToken({ old: cancelRequestToken.new, new: Axios.CancelToken.source() })
		dispatch(getFileListRequest(payload))
		//}
	}, [currentpage])

	useEffect(() => {
		//once switch the AI base wait for 1sec then call the API
		setTimeout(() => {
			setCurrentPage(1)
			const payload = getSearchPayload()
			setCancelRequestToken({ old: cancelRequestToken.new, new: Axios.CancelToken.source() })
			dispatch(getFileListRequest(payload))
		}, 1000)
	}, [selectedBaseId])

	useEffect(() => {
		if (searchedDocs) {
			setDocsToSHow({
				count: searchedDocs.count,
				data: searchedDocs.data,
			})
			setDocumentContent({
				docsToSHow,
			})
			setTotalPages(Math.ceil(searchedDocs.count / 20))
		}
	}, [searchedDocs])

	useEffect(() => {
		//To do: check its use later
		if (resetPage) {
			setCurrentPage(1)
			setResetPage(false)
		}
	}, [resetPage])

	// useEffect(() => {
	//     elementsPagination();
	// }, [columns, searchDocumentsList])

	// useEffect(() => {
	//     setTotalPages(calcTotalPages);
	//     setCurrentPage(1);
	//     return ;
	// }, [calcTotalPages]);

	//Update number of elements shown in list
	/*useEffect(()=>{
        var elements= document.getElementsByClassName("conceptLoaded");
        for (var i=0; i< elements.length; i++){
            if (elements[i].classList.contains('conceptLoaded_page_' + currentpage) === true){
                elements[i].classList.remove("hidePage");
            }else{
                elements[i].classList.add("hidePage");
            }
        }
    },[currentpage]);*/

	// Filtering elements by priority
	useEffect(() => {
		// filtering();
		setSearchDocumentslist({
			count: searchedDocs.data.length,
			data: searchedDocs.data,
		})
		return
	}, [searchedDocs, filterDate, elementsFilter.date, filterList])

	// useEffect(() => {
	//     if (needToFilter === true) {
	//         filtering();
	//         setNeedToFilter(false);
	//     }

	//     return ;
	// }, [needToFilter]);

	// useEffect(() => {
	//     setSearchDocumentslist(searchedDocs);
	//     filtering();
	//     return ;
	//     // eslint-disable-next-line
	// }, [searchedDocs]);

	useEffect(() => {
		if (selectIdentify.elementId !== undefined && selectIdentify.elementId !== "") {
			try {
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-warning")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-danger")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-success")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("circleHidden")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.color = operationsHelper.getTagColor(
					selectIdentify.value,
					tagsApi
				)
			} catch (e) {}
		}
	}, [selectIdentify])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const getSearchPayload = () => {
		const skipCount = currentpage === 1 ? 0 : (currentpage - 1) * RECORDS_PER_PAGE
		const conceptsIds = currentSearch.concepts.map((concept) => concept)
		const filtersObject = { ...filtersButton, ...filterList }
		return {
			searchObject: currentSearch.text,
			filter: filtersObject,
			categories: conceptsIds,
			cancelToken: cancelRequestToken.new,
			skipCount: skipCount,
			selectedTag: currentTag,
			currentSort: currentSort,
		}
	}
	const updateCurrentPage = (e) => {
		setCurrentPage(e.target.value)
	}

	// Pagination
	// const elementsPagination = () => {
	//     if (columns === 3){
	//         setElementsPerPage(21);
	//     } else {
	//         setElementsPerPage(20);
	//     }
	//     setCalcTotalPages(Math.ceil(searchDocumentsList.data.length / elementsPerPage));
	// }

	//Previous Page
	const prevPage = () => {
		const newCurrentPage = currentpage - 1
		if (newCurrentPage === 0) return
		setCurrentPage(newCurrentPage)
	}

	// Next Page
	const nextPage = () => {
		const newCurrentPage = currentpage + 1
		if (newCurrentPage > totalpages) return
		setCurrentPage(newCurrentPage)
	}

	// const filtering = () => {
	//      setSearchDocumentslist({
	//         count: searchedDocs.data.length,
	//         data: searchedDocs.data
	//     });

	// };

	const showSelectFunction = (e) => {
		e.preventDefault()
		if (!show) {
			setSelectIdentify({
				show: true,
			})
		} else {
			setSelectIdentify({
				show: false,
			})
		}
	}
	const updateSelectIdentify = (value, elementId) => {
		dispatch(documentsActions.setPriorityAction(elementId, value))
		setSelectIdentify({
			value: value,
			elementId: elementId,
		})
	}

	// Get dates with yellow marked background
	const maskHightlight = (text, id) => {
		if (text === undefined) {
			text = ""
		}
		let markedText = operationsHelper.cleanHTMLTags(text)
		if (filtersButton.concepts === true) {
			markedText = operationsHelper.highlightConcepts(markedText, conceptsOfSearch, id, currentSearch.text)
		}

		if (filtersButton.searchWord.length !== 0 && filtersButton.specificWord === true) {
			markedText = operationsHelper.highlightWords(markedText, filtersButton.searchWord, id)
		}

		if (filtersButton.dates !== false) {
			markedText = operationsHelper.hightlightDates(markedText, id)
		}

		if (filtersButton.emails === true) {
			markedText = operationsHelper.highlightEmails(markedText, id)
		}

		return { __html: markedText }
	}

	// NUMBER OF COLUMNS
	const showColumnsFunction = (e) => {
		e.preventDefault()
		if (selectColumns == false) {
			setSelectColumns(true)
		} else {
			setSelectColumns(false)
		}
	}
	const renderSwitch = (param, i) => {
		switch (param) {
			case 1:
				return "conceptLoaded col-12 divBlock p-3"

			case 2:
				return "col-6 divBlock p-3"

			case 3:
				return "col-4 divBlock p-3"

			case 4:
				return "col-3 divBlock p-3"

			default:
				return "col-4 divBlock p-3"
		}
	}

	const renderSwitchModule = (param, i) => {
		switch (param) {
			case 2:
				if ((i + 1) % 2 === 0) {
					return "clearfix caso2"
				} else {
					return null
				}
			case 3:
				if ((i + 1) % 3 === 0) {
					return `clearfix caso3 ${i}`
				} else {
					return null
				}
			case 4:
				if ((i + 1) % 4 === 0) {
					return "clearfix caso4"
				} else {
					return null
				}

			default:
				return "clearfix casoDefault"
		}
	}

	const renderSelect = (param) => {
		switch (param) {
			case 1:
				return "selectIdentifyCol1"
			case 2:
				return "selectIdentifyCol2"
			case 3:
				return "selectIdentifyCol3"
			case 4:
				return "selectIdentifyCol4"
			default:
				return "selectIdentifyCol3"
		}
	}

	//Scroll to next hightlight word
	const moveToHightlight = (id) => {
		try {
			var elementMark = document.getElementById(`${id}_divFiles`).getElementsByClassName("mark_element")
			var nextH
			if (hightlightIndex.hasOwnProperty(id) === false || hightlightIndex[id] === null) {
				nextH = 0
			} else {
				nextH = (hightlightIndex[id] + 1) % elementMark.length
			}
			var auxH = hightlightIndex
			auxH[id] = nextH
			setHightlightIndex(auxH)
			document.getElementById(`${id}_divFiles`).scrollTop = elementMark[nextH].offsetTop - 348
		} catch (e) {}
	}

	// OUTSIDE ALERTER
	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setSelectIdentify({ show: false })
					setSelectColumns(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	const onChangeCommentInput = (e) => {
		setComment(e.target.value)
	}

	const updateCommentList = async (docId) => {
		//get comment list form backend
		//const response = await documentsService.getComments(docId);
		const response = await axios.get(`/documents/comments/${docId}`)
		if (response.hasOwnProperty("data") && response.data.hasOwnProperty("data")) {
			let auxCommentList = commentList
			auxCommentList[docId] = response.data.data
			setCommentList(auxCommentList)
			dispatch(documentsActions.storeCommentCountRequest(docId, response.data.data.length))
		}

		return
	}

	const updateCommentContent = (docId) => {
		commentList[docId]?.forEach((item) => {
			if (item.docId === docId) {
				setCommentContent(item)
			}
		})
	}

	const handleInputPageChange = (e) => {
		e.preventDefault()
		setInputPageNumber(e.target.value)
		if (e.target.value !== "" && Number(e.target.value) >= 1 && Number(e.target.value) <= totalpages) {
			updatePageNumber(e, Number(e.target.value), true)
		}
	}

	const handleInputPageBlur = (e) => {
		const pageNumberValue = Math.sign(e.target.value)
		if (!pageNumberValue || Number(e.target.value) > totalpages) {
			setInputPageNumber(currentpage)
		}
	}

	const updatePageNumber = (e, value, IsPageInputChanged) => {
		e.preventDefault()
		if (!IsPageInputChanged) setCurrentPage(value)
		setInputPageNumber(value)
	}

	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	// eslint-disable-next-line
	const { show, value, elementId } = selectIdentify
	const wrapperRef = useRef(null)
	useOutsideAlerter(wrapperRef)
	/* ******************* END VARIABLES ******************* */

	return (
		<div className="section mt-3 componentContainer container-fluid">
			<Fragment>
				<div className="row">
					<div className="col-12 divBlock mb-4">
						{selectColumns ? (
							<div className="selectColumns" ref={wrapperRef}>
								<ul>
									<li
										data-cy="column_1"
										onClick={(e) => {
											setColumns(1)
											showColumnsFunction(e)
										}}
										onMouseOver={(e) => {
											e.preventDefault()
											setSelectOver(1)
										}}
										onMouseOut={(e) => {
											e.preventDefault()
											setSelectOver(false)
										}}
										style={
											selectOver === 1 ? { backgroundColor: "lightgray", cursor: "pointer" } : { cursor: "pointer" }
										}
										className="d-flex justify-content-center"
									>
										1
									</li>
									<li
										data-cy="column_2"
										onClick={(e) => {
											setColumns(2)
											showColumnsFunction(e)
										}}
										onMouseOver={(e) => {
											e.preventDefault()
											setSelectOver(2)
										}}
										onMouseOut={(e) => {
											e.preventDefault()
											setSelectOver(false)
										}}
										style={selectOver === 2 ? { backgroundColor: "lightgray", cursor: "pointer" } : null}
										className="d-flex justify-content-center"
									>
										2
									</li>
									<li
										data-cy="column_3"
										onClick={(e) => {
											setColumns(3)
											showColumnsFunction(e)
										}}
										onMouseOver={(e) => {
											e.preventDefault()
											setSelectOver(3)
										}}
										onMouseOut={(e) => {
											e.preventDefault()
											setSelectOver(false)
										}}
										style={selectOver === 3 ? { backgroundColor: "lightgray", cursor: "pointer" } : null}
										className="d-flex justify-content-center"
									>
										3
									</li>
									<li
										data-cy="column_4"
										onClick={(e) => {
											setColumns(4)
											showColumnsFunction(e)
										}}
										onMouseOver={(e) => {
											e.preventDefault()
											setSelectOver(4)
										}}
										onMouseOut={(e) => {
											e.preventDefault()
											setSelectOver(false)
										}}
										style={selectOver === 4 ? { backgroundColor: "lightgray", cursor: "pointer" } : null}
										className="d-flex justify-content-center"
									>
										4
									</li>
								</ul>
							</div>
						) : null}

						<div className="col-4 divBlock" style={{ paddingLeft: "15px" }}>
							<Tooltip
								title="Select number of columns you want to display in document view, 1 – 4 as per your preference."
								placement="bottom"
								arrow
							>
								<button data-cy="num_columns_button" className="btnModal" onClick={showColumnsFunction}>
									<i className="bi bi-layout-three-columns"></i> Number of columns
								</button>
							</Tooltip>
						</div>
					</div>
				</div>

				{/* <PaginationInput
                        currentpage = {currentpage}
                        totalpages = {totalpages}
                        docsToSHow = {docsToSHow}
                        setCurrentPage = {setCurrentPage}
                    /> */}
				{totalpages > 1 && (
					<div className="col-12 d-flex justify-content-center fs-pagination mb-3">
						<br />
						{/* <div className="flex-column"> */}
						<p>
							<input
								data-cy="input_exclude_terms"
								type="number"
								name="inputNumber"
								id="number"
								className="rounded inputFilterNegative"
								style={{ marginRight: "5px", width: "75px" }}
								min={1}
								max={totalpages}
								onChange={handleInputPageChange}
								onBlur={handleInputPageBlur}
								value={inputPageNumber}
							/>
							of <b>{totalpages}</b>
						</p>
						{/* <p style={{fontSize: '10px'}}>Invalid page number</p> */}
						{/* </div> */}
					</div>
				)}

				<div className="row">
					<div className="col-12 divBlock">
						{docsToSHow.count > 0
							? docsToSHow.data.map((item, i) => (
									<Fragment key={`list_frament_${documentRenderingPrefix}_${item.id}`}>
										<div
											key={`list_item_${documentRenderingPrefix}_${item.id}`}
											className={`conceptLoaded ${renderSwitch(columns, i)} list_item_${documentRenderingPrefix}_${
												item.id
											}`}
											onMouseOver={(e) => {
												e.preventDefault()
												//updateCommentList(item.id);
												setItemId(item.id)
											}}
											style={
												item.id === itemId && showingCommentBox === false
													? { border: "1px solid black", zIndex: 20, position: "relative" }
													: { zIndex: showingCommentBoxId === item.id ? 2 : 1, position: "relative" }
											}
										>
											<h6 className="ml-3 h6-doc-list-view">
												<span style={{ fontSize: "15px" }}>
													{
														<i
															className="bi bi-circle-fill circleIdentify"
															style={{
																color: item?.tags?.id
																	? operationsHelper.getTagColor(item.tags?.id, tagsApi)
																	: "#E2E2E2",
															}}
															id={`doc_id_${item.id}`}
														></i>
													}
												</span>

												<span className="title-doc-list-view">
													{item.hasOwnProperty("filename") && item.filename !== null
														? item.filename.length <= 30
															? item.filename
															: item.filename.substring(0, 30) + "..."
														: null}
												</span>
												{/* <i
													className="fas fa-solid fa-comment comentario-icon comment-icon-list-view"
													onClick={(e) => {
														e.preventDefault()
														setShowingCommentBox(true)
														updateCommentList(item.id)
														setShowingCommentBoxId(item.id)
													}}
												>
													<span style={{ fontSize: "12px", verticalAlign: "middel" }}>
														{getCommentsCount(item.comments)}
													</span>
												</i> */}
											</h6>

											<div className="commentListDocView">
												<CommentsList
													showingCommentBoxId={showingCommentBoxId}
													setShowingCommentBox={setShowingCommentBox}
													item={item}
													commentList={item.comments}
													idElement={idElement}
													setIdElement={setIdElement}
													setShowingCommentBoxId={setShowingCommentBoxId}
													addClassName="addNewCommentListView"
												/>
											</div>

											<div id={`${item.id}_divFiles`} className="divScrollFiles ml-3">
												<div className="mt-2 mb-2">
													<MetadataLayoutDetails
														documentMetadata={documentMetadata}
														item={item}
														maskHightlight={maskHightlight}
													></MetadataLayoutDetails>
												</div>
												{documentContent.hasOwnProperty(item.id) && (
													<>
														<p
															id={`${item.id}_document_content_div`}
															style={{ wordBreak: "break-all", wordWrap: "break-word" }}
															/*dangerouslySetInnerHTML={maskHightlight(item.content,item.id)}*/
															dangerouslySetInnerHTML={maskHightlight(item.content, item.id)}
														></p>
													</>
												)}

												{/* <CommentsDetailsModal
													commentCount={comentsCount[item.id]}
													commentList={item.comments}
													docId={item.id}
												/> */}
											</div>

											{item.id === itemId ? (
												<div
													className="col-12 divBlock d-flex justify-content-between align-items-center"
													style={columns === 4 ? { fontSize: "12px", marginLeft: "0px" } : null}
												>
													<div className="col-4 divBlock d-flex justify-content-center">
														<a
															data-cy="highlight_button_documents_view"
															onClick={(e) => {
																e.preventDefault()
																moveToHightlight(item.id)
															}}
															className="btnModal"
															style={{ textDecoration: "none" }}
														>
															<i className="bi bi-star"></i> Highlight
														</a>
													</div>
													<div className="col-4 divBlock d-flex justify-content-center">
														{/* <TagsUpdateDropdown idItem={item.id} updateSelectIdentify={updateSelectIdentify} /> */}
													</div>
													<div className="col-3 divBlock d-flex justify-content-center hide">
														<button className="btnModal">
															<i className="bi bi-printer"></i> Print
														</button>
													</div>
													<div className="col-4 divBlock d-flex justify-content-center">
														<button
															data-cy="download_button_documents_view"
															className="btnModal"
															onClick={(e) => {
																e.preventDefault()
																dispatch(
																	documentsActions.downloadDocumentAction(item.file_id, item.file_name)
																)
															}}
															disabled={
																item.hasOwnProperty("id") &&
																downloadDocs.hasOwnProperty(item.id) &&
																downloadDocs[item.id].downloading === true
															}
														>
															{item.hasOwnProperty("id") &&
															downloadDocs.hasOwnProperty(item.id) &&
															downloadDocs[item.id].downloading === true ? (
																<>
																	<div
																		className="spinner-border text-dark"
																		role="status"
																		style={{ width: "15px", height: "15px" }}
																	>
																		<span className="visually-hidden">Loading...</span>
																	</div>{" "}
																	Downloading...
																</>
															) : (
																<>
																	<i className="bi bi-download"></i> Download
																</>
															)}
														</button>
													</div>
													{/* <div className="col-4 divBlock d-flex justify-content-center hide">
                                                    <button className="btnModal">
                                                        <i className="bi bi-shte"></i> Share
                                                    </button>
                                                </div> */}
												</div>
											) : (
												<div className="col-12 divBlock" style={{ height: "30px" }}></div>
											)}
										</div>
										<div className={renderSwitchModule(columns, i)}></div>
									</Fragment>
							  ))
							: null}
					</div>

					<Pagination
						currentpage={currentpage}
						prevPage={prevPage}
						totalpages={totalpages}
						docsToSHow={docsToSHow}
						nextPage={nextPage}
						setCurrentPage={setCurrentPage}
					/>
				</div>
			</Fragment>
		</div>
	)
}

export default FilesList
